
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/electronics/home-appliances-pos-billing-software",
      function () {
        return require("private-next-pages/electronics/home-appliances-pos-billing-software.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/electronics/home-appliances-pos-billing-software"])
      });
    }
  